export default {"src":"/_next/static/media/travel-protection-programme.13d444f6.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};